enum ReturnStatus {
    WaitingApproval = 'WAITING_APPROVAL',
    FreeToReturn = 'FREE_RETURN',
    AwaitDisassembly = 'AWAIT_DISASSEMBLY',
    Returned = 'RETURNED',
    Processing = 'PROCESSING',
}

export default ReturnStatus;
